import axiosInstance from '@/api/axiosInstance';
import { FetchSkillsParams, FetchSkillsResponse } from './types';

/**
 * Fetch skills with pagination and filtering
 * GET /api/learning-center/skills
 */
export const fetchSkills = async (
  params?: FetchSkillsParams
): Promise<FetchSkillsResponse> => {
  try {
    const response = await axiosInstance.get<FetchSkillsResponse>(
      '/api/learning-center/skills',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching skills:', error);
    throw error;
  }
};
